import { v4 as uuidv4 } from 'uuid';

import { IKnmReason248 } from 'APIPackage/KnmModule/interfaces/IKnmReason248';
import { createKnmReasonExtendedSelectOption } from 'CorePackage/CatalogsModule/common/createKnmReasonTypeSelectOption';
import { getDictionarySelectOptionWithState } from 'CorePackage/DictionariesModule/common/getDictionarySelectOptionWithState';
import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { createKnmOrderSelectOption } from '../../../KnmPackage/MainModule/common/createKnmOrderSelectOption';
import { IKnmPmForm } from '../../MainModule/interfaces/IKnmPmForm';
import { getFullNameGuarantor } from './getFullNameGuarantor';
import { IKnmPmPlanKnmSelectOption } from '../interfaces/IKnmPmPlanKnmSelectOption';
import { convertKnmDataConditionTypeToFormValue } from '../../../KnmPackage/KnmDocumentsModule/common/convertKnmDataConditionTypeToFormValue';
import { KnmSystemTypesEnum } from '../../../KnmPackage/MainModule/enums/KnmSystemTypesEnum';

interface IConvertInitialReasonsPmToFormDateProps {
  initialReasons: IKnmReason248[] | null | undefined;
  state: IRootState;
  initialFormValues?: IKnmPmForm;
  getPlanKnmById?: (knmIdLink: number | undefined) => IKnmPmPlanKnmSelectOption | undefined;
}

export const convertInitialReasonsPmToFormDate = ({
  initialReasons,
  state,
  initialFormValues,
  getPlanKnmById,
}: IConvertInitialReasonsPmToFormDateProps): IKnmPmForm['reasonsPm'] => {
  return initialReasons?.map((item, index) => {
    const { order, reason, numGuid, knmIdLink } = item;

    const initialType = convertKnmDataConditionTypeToFormValue(state, KnmSystemTypesEnum.PM, reason);

    return {
      ...item,
      ...initialFormValues?.reasonsPm?.[index],
      type:
        reason && initialType
          ? createKnmReasonExtendedSelectOption(reason, initialType, reason?.flagProfvizit, reason?.inspectionResults)
          : undefined,
      text: reason?.text ?? undefined,
      ervkUuid: reason?.ervkUuid || undefined,
      title: reason?.title || undefined,
      shortTitle: reason?.shortTitle || undefined,
      date: convertInitialKnmDateToFormDate(reason?.date, DATE_FORMAT_LONG_FNS),
      riskIndicators:
        item.riskIndicators?.map(indicatorValue => {
          const indicatorSelectOption = getDictionarySelectOptionWithState<typeof DictionaryUUIDsEnum.RISK_INDICATORY>(
            state,
            indicatorValue?.riskIndicator?.dictId,
            indicatorValue?.riskIndicator?.dictVersionId,
          );

          return {
            guid: indicatorValue?.guid,
            riskIndicator: indicatorSelectOption,
            indicatorRiskAuto: indicatorValue?.indicatorRiskAuto || undefined,
            indicatorRiskAttachment: indicatorValue.indicatorRiskAttachment || undefined,
            isNew: false,
          };
        }) || undefined,
      inspectionResults: item?.reason?.inspectionResults,
      assignmentNumber: reason?.assignmentNumber || undefined,
      assignmentDate: convertInitialKnmDateToFormDate(reason?.assignmentDate, DATE_FORMAT_LONG_FNS),
      requirementDetails: reason?.requirementDetails || undefined,
      dateRequirement: convertInitialKnmDateToFormDate(reason?.dateRequirement, DATE_FORMAT_LONG_FNS),
      dateBegin: convertInitialKnmDateToFormDate(reason?.dateBegin || reason?.type?.dateBegin, DATE_FORMAT_LONG_FNS),
      dateEnd: convertInitialKnmDateToFormDate(reason?.dateEnd || reason?.type?.dateEnd, DATE_FORMAT_LONG_FNS),
      listId: numGuid || uuidv4(),
      order: order ? createKnmOrderSelectOption(order) : undefined,
      fullName: getFullNameGuarantor(order?.guarantors[0]),
      knmIdLink,
      planKnm: getPlanKnmById?.(item.knmIdLink),
      links: item.reason?.links || undefined,
      lastConductedKnmDate: convertInitialKnmDateToFormDate(reason?.lastConductedKnmDate, DATE_FORMAT_LONG_FNS),
      programNumber: item?.reason?.programNumber || undefined,
      programAttachment: item?.reason?.programAttachment || undefined,
    };
  });
};
